import { addValidationRule } from '@akihirotakamura/formsy-react'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

addValidationRule('isPhone', (values, value) => {
  if (!value || value === '') return true
  if (value.match(/^[1-9-]+$/)) return false
  const phone = parsePhoneNumberFromString(value, 'JP')
  return phone && phone.isValid()
})
